module.exports = __webpack_public_path__ + "static/media/management_key_black.31decffe.svg";